import { Link, Typography } from '@material-ui/core';
import { createElement, Fragment } from 'react';

import { SubType } from '../../../../hooks/SearchAsset/useTypeAndSubType';

type Props = {
  subType: SubType;
  className?: string;
};

export const Credit = ({ subType, className }: Props) => {
  return (
    <>
      {['pexels', 'pixabay', 'unsplash'].includes(subType.name) && (
        <Typography className={className}>
          Provided by&nbsp;
          <Link href={`https://${subType.name}.com/`} target="_blank">
            {subType.name.replace(/^[a-z]/g, (s) => s.toUpperCase())}
          </Link>
        </Typography>
      )}
    </>
  );
};
